import React from 'react';
import { IoIosClose } from "react-icons/io";
import { analytics } from '../../firebase';
import { logEvent } from 'firebase/analytics';


import styles from './ImageOverlay.module.css';

// Helper function to get the correct YouTube embed URL
const getYouTubeEmbedUrl = (url) => {
  if (!url) return '';
  // Extracts video ID from various YouTube URL formats
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  const videoId = (match && match[2].length === 11) ? match[2] : null;

  if (!videoId) return '';

  // Construct the URL with parameters to hide controls and branding
  const params = new URLSearchParams({
    autoplay: 1,
    controls: 0,
    showinfo: 0,
    modestbranding: 1,
    loop: 1,
    rel: 0,
    iv_load_policy: 3,
    playlist: videoId, // Required for loop to work
    enablejsapi: 1 // Enable the JavaScript API
  });

  return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
};



export const ImageFrame = ({ children }) => {
  return (
    <div className={styles.imageContainer}>
      {children}
    </div>
  )
}

export const ImageOverlay = ({ src, alt, item, type }) => {
  const [isImageLoaded, setImageLoaded] = React.useState(false);
  const [flipped, setFlipped] = React.useState(false);
  const [audioError, setAudioError] = React.useState(false);

  const pauseAllAudio = () => {
    let audioPlayers = document.querySelectorAll('audio');
    for (let i = 0; i < audioPlayers.length; i++) {
      audioPlayers[i]?.pause();
    }
  }

  const pauseAllVideo = () => {
    let iframePlayers = document.querySelectorAll('iframe');
    for (let i = 0; i < iframePlayers.length; i++) {
      // Use postMessage to interact with the YouTube Iframe API and pause the video
      // This is more efficient than checking which ones are open, as that requires another postMessage
      if (iframePlayers[i].src.includes('youtube.com')) {
        iframePlayers[i].contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          'https://www.youtube.com'
        );
      }
    }
  }

  const pauseAllMedia = () => {
    pauseAllAudio();
    pauseAllVideo();
  }

  const handleButtonClick = (buttonType) => {
    if (analytics) {
      logEvent(analytics, 'item_button_click', {
        item_title: item.title,
        button_type: buttonType
      });
    }
    pauseAllMedia();
  };

  const handleAudioPlay = () => {
    if (analytics) {
      logEvent(analytics, 'item_audio_play', {
        item_title: item.title
      });
    }
  };

  return (
    <ImageFrame>
      <div
        style={{ visibility: isImageLoaded ? 'visible' : 'hidden', cursor: 'pointer' }}
        onClick={() => {
          // Clear existing audio errors
          setAudioError(false);

          // Only way to unflip is to press the exit button
          if (flipped)
            return;

          pauseAllMedia();
          setFlipped(!flipped);
        }}
      >
        <img
          className={type === "arrangement" ? styles.arrangementImg : styles.transcriptionImg}
          src={src}
          alt={alt}
          onLoad={() => setImageLoaded(true)}
          onError={() => console.log(`Failed to load image ${alt}`)}
        />

        {item.specialtext && item.showspecialtext &&
          <div className={styles.topOverlay}>
            <div><span className={styles.topOverlayText}>{item.specialtext}</span></div>
          </div>
        }

        {item.commissionedby && item.showcommissiontext &&
          <div className={styles.topOverlay}>
            <div><span style={{ marginRight: 5 }}>🖋️</span><span className={styles.topOverlayText}>Commissioned by {item.commissionedby}</span></div>
          </div>
        }

        <div className={styles.middleOverlay}>
          {/* <div><FaCirclePlay className="play-icon" color="white" size="3rem" /></div> */}
          <i className={`fa fa-play-circle ${styles.playIcon}`} />
        </div>


        <div className={styles.bottomOverlay}>
          <h3 className={styles.songTitle}>{item.title}</h3>
          <div><em><span className={styles.subscriptText}>by </span><span className={styles.byText}>{item.by}</span></em></div>
          <div className={styles.partsText}>{item.parts}</div>
        </div>

        {flipped &&
          <div className={styles.overlay}>
            <div className={styles.exitContainer} onClick={() => setFlipped(false)}>
              <IoIosClose className={styles.exitIcon} size="2rem" />
            </div>

            {/* <p className={styles.itemDesc}>Genres: {item.Genres}</p>
          <p className={styles.itemDesc}>Level: {item.Level}</p> */}

            {type === "arrangement" && !audioError &&
              <div className={styles.htmlAudioContainer}>
                <audio
                  className={styles.audio}
                  controls
                  autoPlay
                  controlsList="nodownload noplaybackrate nomute notimeremaining"
                  onPlay={handleAudioPlay}
                  onError={() => {
                    console.error(`Failed to load audio: ${item.mp3}`);
                    setAudioError(true);
                  }}
                >
                  <source src={`${process.env.PUBLIC_URL}/static/products/${item.id}/${item.id}.mp3`} type="audio/mp3" />
                  There was an error playing or loading the audio.
                </audio>
              </div>
            }

            {type === "transcription" && item.youtube &&
              <iframe
                title={item.title}
                width="100%"
                height="100%"
                src={getYouTubeEmbedUrl(item.youtube)}
                allow="accelerometer; autoplay; encrypted-media;"
                frameBorder="0"
              />
            }

            {/*

            <Spotify link={item.Spotify} />

            <div className={styles.iconContainer}>
              <a href={item.Youtube} target="_blank" rel="noopener noreferrer"><i className="fa fa-youtube icon" aria-label="Youtube Link"/></a><a href={item.Spotify} target="_blank" rel="noopener noreferrer"><i className="fa fa-spotify icon" aria-label="Spotify Link"/></a>
            </div> */}
            <div className={styles.mainContent}>
              <a
                style={{ marginRight: 10 }}
                href={`/store/${item.id}`}
              >
                <button className={styles.actionButton} onClick={() => handleButtonClick('more_info')}>
                  <span className={styles.buttonText}>MORE INFO</span>
                </button>
              </a>

              <a
                href={`/store/${item.id || item.title.toLowerCase().replace(/\s+/g, '-')}?checkout=true`}
              >
                <button className={styles.actionButton} onClick={() => handleButtonClick('purchase')}>
                  <span className={styles.buttonText}>PURCHASE</span>
                </button>
              </a>
            </div>
          </div>
        }

        {/* <div className={styles.overlay}>
            <div className={styles.iconContainer}>
              <a href={item.Youtube} target="_blank" rel="noopener noreferrer"><i className="fa fa-youtube icon" aria-label="Youtube Link"/></a><a href={item.Spotify} target="_blank" rel="noopener noreferrer"><i className="fa fa-spotify icon" aria-label="Spotify Link"/></a>
            </div>

            <h1>{item.Title}</h1>
            <h2 className={styles.opb}>{item.By}</h2>
            <div>{item.Parts}</div>
            <p><a href={item.Gumroad} target="_blank" rel="noopener noreferrer">Purchase</a></p>
          </div> */}
      </div>
    </ImageFrame>
  );
};